import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    Typography
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { Alerts } from "../../../components/alerts/Alerts.tsx";
import { reassignRoutingOfMultipleBoxes } from "../../../config.js";

const reassignmentSchema = yup.object().shape({
    origin_route: yup.string().required("Ruta requerida"),
});

const ReassignmentRouteDialog = ({ openReassignmentDialog, onClose, routesListData, delivery, pickup, selectedData, token, auth, reloadData }) => {

    const {
        alertSuccess,
        showErrorRequest,
    } = Alerts();

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            console.log('Payload reasignación:', values);
            let res = await reassignRoutingOfMultipleBoxes(token, values);
            const data = await res.json();
            console.log('Respuesta backend:', data);

            if (!res.ok || data.detail || data.error) {
                if (res.status === 401 || res.status === 403) {
                    showErrorRequest("No tiene autorización o su sesión ha expirado", auth);
                } else {
                    showErrorRequest(data.detail || data.error || data.message || 'Error al reasignar');
                }
                return;
            }

            alertSuccess('Registro Reasignado', 'Se reasignaron los registros correctamente', undefined);
            reloadData();
            onClose();
        } catch (error) {
            console.error("Error al reasignar:", error);
            showErrorRequest("Error en el servidor, intente más tarde");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Dialog open={openReassignmentDialog} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Reasignar ruta</DialogTitle>
            <Formik
                initialValues={{
                    origin_route: "",
                    pickup: pickup,
                    delivery: delivery,
                    //id_box_size: tempsValues.id_box_size,
                }}
                validationSchema={reassignmentSchema}
                onSubmit={handleSubmit}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting
                }) => (
                    <form onSubmit={handleSubmit}>
                        <DialogContent sx={{ display: "grid", gap: 2 }}>
                            <Typography variant="body1" sx={{ mt: 2, mb: 3 }}>
                                Se cambiará de ruta las siguientes cajas: {selectedData && selectedData.map(item => item.correlative).join(', ')}
                            </Typography>
                            <FormControl variant="filled" required>
                                <InputLabel id="select-route-label">Seleccione la nueva ruta</InputLabel>
                                <Select
                                    labelId="select-route-label"
                                    id="select-route"
                                    name="origin_route"
                                    value={values.origin_route}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                >
                                    {routesListData?.map((route) => (
                                        <MenuItem key={route.id} value={route.id.toString()}>
                                            {route.route_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </DialogContent>

                        <DialogActions>
                            <Button onClick={onClose} color="inherit">
                                Cancelar
                            </Button>
                            <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                                Guardar
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Formik>
        </Dialog>
    );
};

export default ReassignmentRouteDialog;
